<!--*
 * Modal to show how to use the application
 *
 * @author   pablo.barco
 * @date     2021-02-01
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div class="modal-mask align-content-center">
    <div class="modal-wrapper">
      <div class="modal-container p-5 scrollable">
        <div class="modal-body">
          <smtt-input type="text" full-width :label="'* ' + $t('siteDetails.transitions.comment.label')"
                      @inputValueChange="valueChange" />
        </div>
        <div class="modal-footer">
          <app-button variation="default" @click="closeHandler">
            {{ $t('siteDetails.transitions.comment.cancel.button') }}
          </app-button>
          <app-button variation="primary" :disabled="isConfirmDisabled" @click="confirmHandler">
            {{ $t('siteDetails.transitions.comment.continue.button') }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton';

export default {
  'name': 'TransitionCommentModal',
  'components': { AppButton },
  'props': {
    'onDismiss': Event
  },
  'data': function () {
    return {
      'comment': null,
      'isConfirmDisabled': true,
    }
  },
  'methods': {
    closeHandler() {
      this.$emit('onDismiss');
    },
    confirmHandler() {
      if (!this.isConfirmDisabled) {
        this.$emit('onConfirm', this.comment);
      }
    },
    valueChange(e) {
      this.comment = e.detail.value
      this.isConfirmDisabled = this.comment.trim() === '';
    }
  }
}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  transition: opacity 0.3s ease;
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0 16px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  z-index: 1000;
}

.scrollable {
  overflow: auto;
  max-height: 90vh;
}

.fixed-row .col,.col--auto {
  height: 24px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
